import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLikeMarker, curveGeometryAttributeSetLike} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {curveGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeSetLikeNode, MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ProductOperatorPairParameters} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"
import {
    GeometryProductOperatorPairNode,
    productOperatorPairParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"

export type MeshGeometryProductOperatorCurveGeometryCurveGeometryInputParameters = ProductOperatorPairParameters<
    CurveGeometryAttributeLikeNode,
    CurveGeometryAttributeSetLikeNode,
    CurveGeometryAttributeLikeNode,
    CurveGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<MeshGeometryProductOperatorCurveGeometryCurveGeometryInputParameters> = {
    nodeClass: "MeshGeometryProductOperatorCurveGeometryCurveGeometryInput",
    validation: {
        parameters: productOperatorPairParametersSchema(
            curveGeometryAttributeLike,
            curveGeometryAttributeSetLike,
            curveGeometryAttributeLike,
            curveGeometryAttributeSetLike,
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryProductOperatorCurveGeometryCurveGeometryInput
    extends GeometryProductOperatorPairNode<
        2,
        CurveGeometryAttributeLikeNode,
        CurveGeometryAttributeSetLikeNode,
        CurveGeometryAttributeLikeNode,
        CurveGeometryAttributeSetLikeNode
    >
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    protected override get outputIndexingDim(): 2 {
        return 2
    }
}
